<template>
  <div class="d-flex justify-content-center align-items-center">
    <div
      v-for="(date, index) of dateList"
      :key="index"
      class="date-container"
      :class="{ 'current-day-container': date.isCurrentDate }"
    >
      <span
        class="d-block"
        :class="{ 'text-semibold-white text-size-16': date.isCurrentDate }"
      >
        {{ date.dayName }}
      </span>
      <span
        class="d-block"
        :class="[
          date.isCurrentDate
            ? 'text-semibold-white text-size-36'
            : 'text-medium-black text-size-24',
        ]"
      >
        {{ date.date }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoleculeDisplayCurrentDate",

  data() {
    return {
      dateList: [],
      midnightUpdateTimer: null,
    }
  },

  mounted() {
    this.generateDateList()
    this.midnightUpdate()
  },

  beforeDestroy() {
    clearTimeout(this.midnightUpdateTimer)
  },

  methods: {
    generateDateList() {
      this.dateList = []
      const currentDate = new Date()
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

      // Generate 2 days before current day
      for (let i = 2; i > 0; i--) {
        const prevDate = new Date(currentDate)
        prevDate.setDate(currentDate.getDate() - i)
        this.dateList.push({
          date: String(prevDate.getDate()).padStart(2, '0'),
          dayName: daysOfWeek[prevDate.getDay()],
          isCurrentDate: false,
        })
      }

      // Current day
      this.dateList.push({
        date: String(currentDate.getDate()).padStart(2, '0'),
        dayName: daysOfWeek[currentDate.getDay()],
        isCurrentDate: true,
      })

      // Generate 2 days after current day
      for (let i = 1; i <= 2; i++) {
        const nextDate = new Date(currentDate)
        nextDate.setDate(currentDate.getDate() + i)
        this.dateList.push({
          date: String(nextDate.getDate()).padStart(2, '0'),
          dayName: daysOfWeek[nextDate.getDay()],
          isCurrentDate: false,
        })
      }
    },

    midnightUpdate() {
      this.generateDateList()
      this.midnightUpdateTimer = setTimeout(
        this.midnightUpdate,
        this.msUntilMidnight()
      )
    },

    msUntilMidnight() {
      const now = new Date()
      const night = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1, // set to tomorrow
        0, // hours
        0, // minutes
        0 // seconds
      )
      return night - now
    },
  },
}
</script>

<style lang="scss" scoped>
.date-container {
  padding: 6px 22px;
  margin: 0 6px;
}

.current-day-container {
  background-color: #7367f0;
  border-radius: 6px;
}
</style>
